import React from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import classnames from 'classnames';
import { DotsActionsMenu } from 'components';
import styles from './PublishedComment.scss';

const PublishedComment = ({ comment, isAdminText, actions, wasUpdated }) =>
    <div
        className={classnames(styles.comment, { [styles.updated]: wasUpdated })}
        data-testid={`comments-popOver__comment-${comment.id}`}
    >
        {
            !isEmpty(comment.allowedActions)
            &&
            <DotsActionsMenu
                className={styles.moreOptions}
                actions={actions}
                comment={comment}
            /> 
        }
        <div className={styles.commentHeader}>
            <div
                className={styles.userName}
                data-testid={`comments-popOver__comment-${comment.id}__author`}
            >
                { get(comment, 'author.name', '') }
                {comment.userAdmin &&
                    <span
                        className={styles.isAdmin}
                        data-testid={`comments-popOver__comment-${comment.id}__admin-tag`}
                    >
                        {isAdminText}
                    </span>
                }
            </div>
            <div className={styles.date}>
            {comment.createdAt}
            </div>
        </div>
        <div
            className={styles.commentContent}
            data-testid={`comments-popOver__comment-${comment.id}__content`}
        >
            {comment.content}
        </div>
    </div>;

PublishedComment.propTypes = {
  comment: PropTypes.shape({
    author: PropTypes.shape({
      email: PropTypes.string,
      name: PropTypes.string,
    }),
    createdAt: PropTypes.string,
    content: PropTypes.string,
    userAdmin: PropTypes.bool,
    allowedActions: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  isAdminText: PropTypes.string.isRequired,
  actions: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    label: PropTypes.string,
    icon: PropTypes.string,
    callback: PropTypes.func
  })),
  wasUpdated: PropTypes.bool
};

PublishedComment.defaultProps = {
    actions: [],
    wasUpdated: false
};

export default PublishedComment;
